/* ============================================================
   SINGSPACE ADMIN - LAYOUT ADMIN (Refactorisé)
   ============================================================ */

import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useRoleNavigation } from '../../hooks/useRoleNavigation';
import { navGroups } from '../../constants/navigation.constants';
import { AdminSidebar } from './AdminSidebar';

const allNavItems = navGroups.flatMap((g) => g.items);

export function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const filteredNavItems = useRoleNavigation(allNavItems);
  const allowedPaths = new Set(filteredNavItems.map((i) => i.path));

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      <AdminSidebar user={user} allowedPaths={allowedPaths} onLogout={handleLogout} />
      <main className="admin-main">
        <div className="admin-content">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
